export { default as Collapse } from './collapse';

export * from './type';
export * from './props';

export { CollapseProps } from './collapse';
